<template>
    <div class="announcement-list table-responsive text-center mt-2">
        <table class="table table-striped table-sm">
            <thead class="bg-hub-primary text-white sticky-top">
                <tr>
                    <th class="text-left" style="width: 30%">Name</th>
                    <th style="width: 20%">Extension</th>
                    <th style="width: 50%">Play</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="notification in filtered_notifications" :key="notification.notification_id">
                    <td class="text-left align-middle">{{ notification.name }}</td>
                    <td class="align-middle">
                        <span v-if="notification.extension !== 0">{{ notification.extension }}</span>
                        <span v-else>N/A</span>
                    </td>

                    <td class="align-middle" style="height: 60px">
                        <a class="btn btn-sm w-100 h-100 p-0" @click="playNotification(notification)">
                            <i class="fa fa-play fa-fw h-100 pt-3" style="font-size: 20px; padding-top: 0.8rem;" aria-hidden="true"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            notifications: 'allNotifications',
            logged_in_user: 'loggedInUser',
            scoped_site_id: 'scopedSiteId'
        }),
        filtered_notifications: function () {
            return this.notifications.filter(notification => notification.site_id === this.scoped_site_id)
        }
    },
    created() {
        this.$store.dispatch('setDisabledChangeScopedSite', false)
        this.$store.dispatch('getNotifications')
    },
    methods: {
        playNotification(notification) {
            if(confirm(`You are about to activate an announcement (${notification.name}). Continue?`)) {
                this.$store.dispatch('playNotification', notification);
            }
        }
    }
}
</script>

<style>
.announcement-list {
    height: 40vh;
    border: 1px solid #ccc;
}
</style>